// Suggerimenti di ricerca mentre si scrive nel campo dell'intestazione:
// un elenco cliccabile per tipo (ricette, scritti, ingredienti, raccolte),
// navigabile con le frecce, Invio apre, Esc chiude
export function setupSearchSuggest () {
  const form = document.querySelector('.site-header__search')
  if (!form || form.dataset.suggest) return
  form.dataset.suggest = 'on'
  const input = form.querySelector('input[type=search]')
  const box = document.createElement('div')
  box.className = 'search-suggest'
  box.id = 'search-suggest'
  box.setAttribute('role', 'listbox')
  box.hidden = true
  form.appendChild(box)
  input.setAttribute('role', 'combobox')
  input.setAttribute('aria-autocomplete', 'list')
  input.setAttribute('aria-controls', box.id)
  input.setAttribute('aria-expanded', 'false')
  input.setAttribute('autocomplete', 'off')

  let timer = null
  let request = 0
  let active = -1

  const options = () => Array.from(box.querySelectorAll('[role=option]'))
  const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1 }
  const highlight = (index) => {
    const list = options()
    list.forEach((el, i) => el.setAttribute('aria-selected', i === index ? 'true' : 'false'))
    active = index
    if (list[index]) list[index].scrollIntoView({ block: 'nearest' })
  }

  const render = (groups, query) => {
    box.innerHTML = ''
    if (!groups.length) {
      const empty = document.createElement('p')
      empty.className = 'search-suggest__empty'
      empty.textContent = document.documentElement.lang === 'en' ? 'No results' : 'Nessun risultato'
      box.appendChild(empty)
    }
    groups.forEach((group) => {
      const label = document.createElement('p')
      label.className = 'search-suggest__label'
      label.textContent = group.label
      box.appendChild(label)
      group.items.forEach((item) => {
        const link = document.createElement('a')
        link.href = item.url
        link.className = 'search-suggest__item'
        link.setAttribute('role', 'option')
        if (item.image) {
          const img = document.createElement('img')
          img.src = item.image
          img.alt = ''
          img.loading = 'lazy'
          link.appendChild(img)
        } else {
          const dot = document.createElement('span')
          dot.className = 'search-suggest__dot'
          link.appendChild(dot)
        }
        const text = document.createElement('span')
        text.textContent = item.title
        link.appendChild(text)
        box.appendChild(link)
      })
    })
    const all = document.createElement('a')
    all.href = form.action + '?q=' + encodeURIComponent(query)
    all.className = 'search-suggest__all'
    all.setAttribute('role', 'option')
    all.textContent = (document.documentElement.lang === 'en' ? 'All results for “' : 'Tutti i risultati per “') + query + '”'
    box.appendChild(all)
    box.hidden = false
    input.setAttribute('aria-expanded', 'true')
    active = -1
  }

  input.addEventListener('input', () => {
    clearTimeout(timer)
    const query = input.value.trim()
    if (query.length < 2) { close(); return }
    timer = setTimeout(() => {
      const current = ++request
      fetch(form.action + '.json?q=' + encodeURIComponent(query), { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((groups) => { if (current === request) render(groups, query) })
        .catch(close)
    }, 200)
  })

  input.addEventListener('keydown', (event) => {
    if (box.hidden) return
    const list = options()
    if (event.key === 'ArrowDown') { event.preventDefault(); highlight(Math.min(active + 1, list.length - 1)) }
    else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(Math.max(active - 1, 0)) }
    else if (event.key === 'Enter' && list[active]) { event.preventDefault(); list[active].click() }
    else if (event.key === 'Escape') { close() }
  })

  document.addEventListener('click', (event) => { if (!form.contains(event.target)) close() })
}
